import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { Select, Functions as FN } from "rhombus-react";

import { changePlacement } from "reducers/Social";


export default function PlacementSelector({
	label,
	previewOpts,
}){
	const dispatch = useDispatch();
	const { selectedPlacement } = useSelector(store => ({
		selectedPlacement: store.social.selectedPlacement,
	}));

	function onPlacementChange(newPlacement, oldPlacement){
		return dispatch(changePlacement(newPlacement, oldPlacement));
	}

	return (
		<div className="placement-selector">
			<Select
				label       = {`${label}:`}
				options     = {previewOpts}
				autoFocus   = {true}
				isClearable = {false}
				onChange    = {onPlacementChange}
				value       = {selectedPlacement}
				onMenuScrollToBottom={FN.noop}
			/>
		</div>
	);
}

PlacementSelector.displayName = "PlacementSelector";
PlacementSelector.propTypes = {
	label: PropTypes.string,
	previewOpts: PropTypes.array,
};

PlacementSelector.defaultProps = {
	label: "Placement",
};
